const generatePassword = () => {
  const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const symbols = "!@#$%^&*()-_+=<>?/";

  // Ensure at least one character from each category
  const randomUppercase =
    uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)];
  const randomLowercase =
    lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)];
  const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];

  // Combine all possible characters
  const allCharacters = uppercaseLetters + lowercaseLetters + numbers + symbols;

  // Generate the remaining characters randomly
  let password = "";
  for (let i = 0; i < 6; i++) {
    const randomChar =
      allCharacters[Math.floor(Math.random() * allCharacters.length)];
    password += randomChar;
  }

  // Insert the required characters at random positions
  const randomPosition1 = Math.floor(Math.random() * 9);
  const randomPosition2 =
    Math.floor(Math.random() * (8 - randomPosition1)) + randomPosition1 + 1;

  password =
    password.substring(0, randomPosition1) +
    randomUppercase +
    password.substring(randomPosition1);
  password =
    password.substring(0, randomPosition2) +
    randomLowercase +
    password.substring(randomPosition2);

  // Ensure at least one number in the last position
  password = password.substring(0, 8) + randomNumber;

  return password;
};

export default generatePassword;
